export default {
    data() {
        return {
            propFilters: {
                expandTrigger: "hover",
                lazy: true,
                lazyLoad: this.cascaderLazyloads,
                children: "cities",
                label: "name",
                value: "id",
                multiple: true,
                checkStrictly: true,
                providerId: '',
                // emitPath: false
            },
            provinceFilterList: [], // 地区列表
            address: '',
        };
    },
    methods: {
        /**
         * 获取省级地址列表
         */
        getAreaFilterList() {
            this.axios
                .get( this.getApiUrl( "supplierArea" ), {
                    params: {
                        id: this.providerId
                    }
                } )
                .then( ( res ) => {
                    if ( res.code === 1 ) {
                        this.provinceFilterList = res.data || [];
                    } else {
                        this.$message.warning( res.msg );
                    }
                } )
                .catch( ( err ) => {} );
        },
        /**
         * 动态获取市区
         */
        cascaderLazyloads( node, resolve ) {
            const {
                level,
                data
            } = node;
            if ( level >= 3 ) return resolve();
            let id = data ? data.id : "";
            if ( !id ) return;
            let nodes = [];
            this.axios
                .get( this.getApiUrl( "supplierArea" ), {
                    params: {
                        id: this.providerId,
                        parentId: id
                    }
                } )
                .then( ( res ) => {
                    if ( res.code === 1 ) {
                        nodes = res.data || [];
                        nodes.map( ( o ) => {
                            o.leaf = level > 1 ? true : false;
                        } );
                        resolve( nodes );
                    } else {
                        this.$message.warning( res.msg );
                    }
                } )
                .catch( ( err ) => {} );
        },
    },
    mounted() {

        this.getAreaFilterList(); // 获取省级地址列表
    },
};